<template>
  <div class="product-favourites" v-if="products">
    <div>
      <i18n
        :path="hasFavorites ? 'list.preferred' : 'list.bestselling'"
        tag="h2"
      />
      <div class="grey lighten-2 ">
        <strong>Sono stati trovati {{ products.length }} prodotti</strong>
      </div>
    </div>
    <div style="max-height:100%" v-if="products.length > 0">
      <v-row>
        <v-col
          cols="12"
          sm="6"
          lg="4"
          xl="3"
          v-for="product in products"
          :key="product.productId"
          class="product-col"
        >
          <ProductCard v-bind:product="product" position="list_preferred" />
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
import ProductCard from "@/components/product/ProductCard.vue";
import ProductService from "~/service/productService";

import deliveryReactive from "~/mixins/deliveryReactive";

import { mapGetters } from "vuex";

export default {
  name: "ListPreferred",
  data() {
    return {
      products: []
    };
  },
  components: {
    ProductCard
  },
  mixins: [deliveryReactive],
  computed: {
    ...mapGetters({
      hasFavorites: "cart/hasFavorites"
    }),
    crmLayout() {
      return this.hasFavorites ? 29 : 26;
    }
  },
  methods: {
    async addAllToCart() {},
    async fetchProducts() {
      let response = await ProductService.adv({
        layout: this.crmLayout,
        limit: 50
      });
      this.products = response.products;
    }
  },
  mounted() {
    this.fetchProducts();
  }
};
</script>
